export default __webpack_public_path__ + "static/media/lettermark-diving-eagle-white.307c3894.svg";